/**
 * Typed search object for the `/scores/player` route.
 *
 * Lives in its own file rather than in `sectionSearch.ts` so this route can
 * ship without touching a file six other routes share.
 *
 * Coerce every value, never type-guard it. TanStack's default search parser
 * runs JSON.parse on each raw value, so `?jerseyNumber=8` arrives as the
 * number 8. See `searchParams.ts` for the full rule.
 */
import { coerceOptionalEnum, coerceOptionalString } from "./searchParams";

export const PLAYER_TABS = ["info", "stats", "gameLog"] as const;

export type typePlayerTabKey = (typeof PLAYER_TABS)[number];

export type typePlayerSearch = {
  playerId?: string | undefined;
  name?: string | undefined;
  teamId?: string | undefined;
  teamName?: string | undefined;
  teamAbbreviation?: string | undefined;
  jerseyNumber?: string | undefined;
  position?: string | undefined;
  injuryStatus?: string | undefined;
  tab?: typePlayerTabKey | undefined;
};

export function validatePlayerSearch(
  search: Record<string, unknown>,
): typePlayerSearch {
  return {
    playerId: coerceOptionalString(search.playerId),
    name: coerceOptionalString(search.name),
    teamId: coerceOptionalString(search.teamId),
    teamName: coerceOptionalString(search.teamName),
    teamAbbreviation: coerceOptionalString(search.teamAbbreviation),
    jerseyNumber: coerceOptionalString(search.jerseyNumber),
    position: coerceOptionalString(search.position),
    injuryStatus: coerceOptionalString(search.injuryStatus),
    tab: coerceOptionalEnum(search.tab, PLAYER_TABS),
  };
}
